<template>
  <div class="step-container scrollPosition step-10">
    <div class="step-header">
      <h2 class="step-title">Gratulation! Sie sind mit der Eingabe fertig.</h2>
      <p class="step-text">
        Geben Sie hier Ihre persönlichen Daten ein und schon bekommen Sie einen
        Richtwert per E-Mail zugeschickt, den wir auf Basis Ihrer Angaben und
        unter Nutzung von Drittanbieterdiensten errechnen. Eine Übersicht der
        Drittanbieter und damit verbundene Urheber-, Nutzungs- und Lizenzrechte
        finden Sie
        <a
          href="https://www.sparkasse.at/tiny/externe-datenquellen-immobilienkalkulator"
          >hier</a
        >.
      </p>
    </div>
    <div class="step-body">
      <div class="row gx-5">
        <div class="col-md-3">
          <DropdownSelector
            id="dropdown-1"
            v-model="fields.kundeAnrede.value"
            placeholder="Anrede*"
            :elements="kundeAnredeValues"
            @update:modelValue="validate('kundeAnrede')"
            :state="fields.kundeAnrede.state"
          />
        </div>
        <div class="col-md-4">
          <TextField
            v-model="fields.kundeVorname.value"
            placeholder="Vorname*"
            @change="validate('kundeVorname')"
            :state="fields.kundeVorname.state"
          />
        </div>
        <div class="col-md-5">
          <TextField
            v-model="fields.kundeNachname.value"
            placeholder="Nachname*"
            @change="validate('kundeNachname')"
            :state="fields.kundeNachname.state"
          />
        </div>
        <div class="col-md-7">
          <TextField
            v-model="fields.kundeEmail.value"
            placeholder="E-Mail*"
            @change="validate('kundeEmail')"
            :state="fields.kundeEmail.state"
          />
        </div>
      </div>
      <div class="agb-section">
        <CheckBox
          label="Durch Verwendung des s Immobilienkalkulators nehme ich die <a href='http://www.sparkasse.at/tiny/nutzungsbedingungen-ibw-web' target='_blank'>Nutzungsbedingungen</a> der Erste Bank und Sparkasse zur Kenntnis.*"
          v-model="fields.nutzungsbedingungen.value"
          @update:modelValue="validate('nutzungsbedingungen')"
          :state="fields.nutzungsbedingungen.state"
          class="mb-3"
          :class="{ 'pe-none': pending }"
        />
        <CheckBox
          v-bind:label="textEinverstaendnis"
          v-model="fields.newsletter.value"
          :class="{ 'pe-none': pending }"
        />
        <div class="agb-section--info">
          <small>* Pflichtfeld</small>
          <p v-if="showTextVerkauf">
            Wenn Sie an einem Verkauf der Immobilie interessiert sind, werden
            Ihre Daten für den Zweck einer Kontaktaufnahme an die s REAL
            Immobilienvermittlung GmbH weitergegeben. Es gelten die
            <a href="https://www.sreal.at/de/datenschutz"
              >Datenschutzbestimmungen</a
            >
            der s REAL.
          </p>
          <p v-if="showTextKauf">
            Wenn Sie an einem Kauf der Immobilie interessiert sind, werden Ihre
            Daten für den Zweck einer Kontaktaufnahme an die s Bausparkasse
            weitergegeben. Es gelten die
            <a
              href="https://www.sbausparkasse.at/de/ueber-die-s-bausparkasse/impressum/datenschutz"
              >Datenschutzbestimmungen</a
            >
            der s Bausparkasse.
          </p>
          <p>
            Mit Bestätigung Ihrer Daten erhalten Sie eine E-Mail mit einem Link
            auf das Ergebnis der Selbstberechnung.
          </p>
        </div>
      </div>
    </div>
    <div class="step-footer">
      <div class="row align-items-center">
        <div class="col-md-3 col-12">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
        <div class="col-md-5 col-12 next-container">
          <button
            class="compute-check-btn"
            @click="computeCheck"
            :disabled="pending"
          >
            <span :class="{ invisible: pending }"
              >Jetzt Richtwert anfordern</span
            >
            <div
              v-if="pending"
              class="spinner-overlay cursor-default"
            >
              <PulseLoader color="white" />
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TextField from "@/components/shared/TextField.vue";
import DropdownSelector from "@/components/shared/DropdownSelector.vue";
import CheckBox from "@/components/shared/CheckBox.vue";
import DataService from "@/services/DataService.js";
import Constants from "@/constants.js";
import {
  getFromStorage,
  saveToStorage,
  checkValidFields,
  checkInvalidFields,
  containsInvalidFields,
  validateField,
  getDataForBaugrundstueckEvaluation,
  clearStorage,
  isSet,
sendMailEB,
getAnredeValues,
} from "@/utils.js";
export default {
  name: "baugrundstueck-step-4",
  components: {
    TextField,
    DropdownSelector,
    CheckBox,
  },
  data() {
    return {
      fields: {
        kundeAnrede: { validators: ["required"] },
        kundeVorname: { validators: ["required"] },
        kundeNachname: { validators: ["required"] },
        kundeEmail: { validators: ["email", "required"] },
        nutzungsbedingungen: {
          value: "false",
          validators: ["checked"],
        },
        newsletter: { value: "false" },

      },
      pending: false,
    };
  },
  methods: {
    goBack() {
      this.$router.push("/baugrundstueck-step-3");
    },
    async computeCheck() {
      checkInvalidFields(this.fields);
      if (!containsInvalidFields(this.fields)) {
        saveToStorage(this.fields);
        this.pending = true;
        const evalData = getDataForBaugrundstueckEvaluation();
        const response = await DataService.createBaugrundstueckEvaluation(evalData);
        const f_zweck = sessionStorage.getItem(Constants.PREFIX + ".f_zweck");
        if (response.status === 200) {
          if (isSet(this.fields.newsletter.value)) {
            await DataService.subscribeToNewsletter();
          }
          clearStorage();
          const body = await response.json();
          sessionStorage.setItem(
            Constants.PREFIX + ".vonVerkehrswert",
            body["vonVerkehrswert"]
          );
          sessionStorage.setItem(
            Constants.PREFIX + ".bisVerkehrswert",
            body["bisVerkehrswert"]
          );
          if(process.env.VUE_APP_MANDANT != 'sbau' && f_zweck == 'VERKAUF') {
            sendMailEB(evalData, body);
          }
          this.$router.push("/baugrundstueck-step-5b");
        } else {
          this.$router.push("/baugrundstueck-step-5c");
        }
      }
    },
    validate(name) {
      const field = this.fields[name];
      field.state = validateField(field.value, field.validators);
    },
  },
  mounted() {
    this.$emit("setStep", "baugrundstueck", 5);
    getFromStorage(this.fields);
    checkValidFields(this.fields);
  },
  computed: {
    // a computed getter
    textEinverstaendnis() {
      // `this` points to the component instance
      return process.env.VUE_APP_MANDANT == 'sbau' ? "Mit der Anmeldung zum Newsletter bin ich einverstanden, dass die s Bausparkasse meine angegebenen Kontaktdaten für Newsletter verwendet und mir Newsletter zusenden darf. Meine Zustimmung gilt bis auf Widerruf. Detaillierte Informationen zur Datenverarbeitung finde ich unter <a href='https://www.sbausparkasse.at/datenschutz' target='_blank' rel='noopener'>www.sbausparkasse.at/datenschutz</a>." : "Ich bin damit einverstanden, dass ich künftig per Post, Telefon, E-Mail und dgl. von der <a href='https://www.sparkasse.at/sgruppe/wir-ueber-uns' target='_blank' rel='noopener'>Sparkassengruppe</a> über Produkte, Services und Events informiert werde. Meine persönlichen Daten werden nur dafür genutzt. Diese Zustimmung kann ich jederzeit widerrufen. Unsere Informationen zum Datenschutz finden Sie <a href='https://www.sparkasse.at/sgruppe/wir-ueber-uns/datenschutz-sicherheit' target='_blank'>hier</a>."
    },
    showTextVerkauf() {
      const f_zweck = sessionStorage.getItem(Constants.PREFIX + ".f_zweck");
      return f_zweck == 'VERKAUF';
    },
    showTextKauf() {
      const f_zweck = sessionStorage.getItem(Constants.PREFIX + ".f_zweck");
      return process.env.VUE_APP_MANDANT == 'sbau' && f_zweck == 'KAUF' || process.env.VUE_APP_MANDANT == 'sbau' && f_zweck == 'BESTAND';
    },
    kundeAnredeValues() {
      return getAnredeValues();
    }

  },
};
</script>
<style scoped>
.step-body .row {
  row-gap: 45px;
}
@media only screen and (max-width: 768px) {
  .step-body .row {
    row-gap: 30px;
  }
}
</style>
